
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import TransferDom from 'vux/src/directives/transfer-dom/index.js'


import {mapGetters} from 'vuex'

export default {
computed:mapGetters([
'headShow',
'loading',
'footerShow',
'pageTitle'
]),
data(){
let data={

}
return data
},
mounted() {

},
directives: {
TransferDom
},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon
}
}



// WEBPACK FOOTER //
// ./src/components/memberHome.vue